import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'react-tiny-popover';

import * as S from './styled';

const Popup = ({
  children,
  trigger,
  isOpen,
  setPopupVisible,
  handleOuterAction,
  triggerWidth,
  triggerHeight,
  triggerStyle,
  clickOutsideCapture,
  zIndex,
  containerStyle,
  align,
  positions,
}) => {
  const [isPopupOpen, setIsOpen] = useState(false);
  const isStateless = isOpen === null || isOpen === undefined;
  const shouldOpen = isStateless ? isPopupOpen : isOpen;

  return (
    <Popover
      isOpen={shouldOpen}
      content={<S.PopupBody>{children}</S.PopupBody>}
      align={align}
      positions={positions}
      clickOutsideCapture={clickOutsideCapture}
      containerStyle={{
        zIndex,
        ...containerStyle,
      }}
      onClickOutside={(ev) => {
        if (isStateless) {
          setIsOpen(false);
        } else {
          handleOuterAction(ev);
        }
      }}
    >
      <S.Trigger
        width={triggerWidth}
        height={triggerHeight}
        style={triggerStyle}
        onClick={(ev) => {
          ev.stopPropagation();
          if (isStateless) {
            setIsOpen(true);
          } else {
            setPopupVisible();
          }
        }}
      >
        {trigger}
      </S.Trigger>
    </Popover>
  );
};

Popup.propTypes = {
  /**
   * Contents to render in popup
   */
  children: PropTypes.node,
  /**
   * Custom trigger
   */
  trigger: PropTypes.node,
  isOpen: PropTypes.bool,
  triggerStyle: PropTypes.object,
  handleOuterAction: PropTypes.func,
  setPopupVisible: PropTypes.func,
  align: PropTypes.string,
  zIndex: PropTypes.string,
  containerStyle: PropTypes.object,
  positions: PropTypes.arrayOf(PropTypes.string),
};

Popup.defaultProps = {
  children: [],
  trigger: [],
  isOpen: null,
  clickOutsideCapture: false,
  handleOuterAction: () => {},
  setPopupVisible: () => {},
  zIndex: '100',
  containerStyle: {},
  triggerStyle: {},
  align: 'center',
  positions: ['top', 'left', 'right', 'bottom'],
};

export default Popup;
